import { PopupController } from './popup-controller.js'
import { handleCrossPageAttribution } from './cross-page-attribution.js'

const DEFAULT_STYLES_ID = 'poppy-default-styles'

/**
 * Inject default fade-in styles once, with `:where()` so the specificity is 0.
 * Any rule the designer writes in their own CSS / Webflow Style panel wins
 * automatically — including `transition-duration`, which the controller reads
 * to time the dismiss display:none.
 */
function injectDefaultStyles() {
  if (typeof document === 'undefined') return
  if (document.getElementById(DEFAULT_STYLES_ID)) return
  const style = document.createElement('style')
  style.id = DEFAULT_STYLES_ID
  // `display: none` keeps the popup hidden until the controller shows it
  // (script sets `display: flex` inline at show time, which wins over this rule).
  style.textContent =
    ':where([data-popup]){display:none;opacity:0;transition:opacity 250ms ease-out;}' +
    ':where([data-popup].popup-visible){opacity:1;}'
  // Insert at the top of <head> so author stylesheets always come later
  // and override the defaults effortlessly.
  const head = document.head || document.documentElement
  head.insertBefore(style, head.firstChild)
}

export function bootstrap() {
  // 1. Cross-page attribution always runs (independent of popup presence)
  try {
    handleCrossPageAttribution()
  } catch (err) {
    console.error('[popup] cross-page attribution failed', err)
  }

  // 2. Find pop-up element(s)
  const elements = document.querySelectorAll('[data-popup]')
  if (elements.length === 0) return
  if (elements.length > 1) {
    console.warn(
      `[popup] Multiple [data-popup] elements found (${elements.length}). Only the first will be activated.`
    )
  }

  // 3. Inject default fade-in styles (no-op if already present or no popup)
  injectDefaultStyles()

  // 4. Start the first one
  try {
    const controller = new PopupController(elements[0])
    controller.start()
  } catch (err) {
    console.error('[popup] controller setup failed', err)
  }
}

// Auto-run when loaded as a script
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap, { once: true })
  } else {
    bootstrap()
  }
}
